import React from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { topics } from "./ForumLogic"
import { OpenSansText } from "@Components/CustomText/OpenSansText"

const Forum = (props) => {
    const { navigation } = props
    const navigateTo = (axisId) =>
        navigation.navigate("ForumTopic", {
            axisId: axisId
        })

    return (
        <View style={styles.container}>
            <ScrollView contentContainerStyle={{ paddingBottom: 150 }} showsVerticalScrollIndicator={false}>
                <View style={styles.content}>
                    {topics.map((item, index) => (
                        <TouchableOpacity
                            activeOpacity={0.5}
                            onPress={() => navigateTo(item.id)}
                            style={styles.marginBottom}
                            key={index}
                        >
                            {item.content}
                        </TouchableOpacity>
                    ))}
                </View>
            </ScrollView>
        </View>
    )
}

export default Forum
